import UserNoInfoPanel from './UserNoInfoPanel';

export default UserNoInfoPanel;
